import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { renderStore } from '../../store/renderStore';
import { editorStore } from '../../store/editorStore';
import JointPolygon from './JointPolygon';

/**
 * Container component that renders all joint polygons.
 * This component manages the lifecycle of joint polygon renderings
 * and provides a clean integration point for the floorplan rendering pipeline.
 */
const JointPolygonStructure: React.FC = observer(() => {
  // Hooks must always execute to keep React's hook order stable
  const renderCountRef = useRef(0);
  const jointPolygons = Array.from(renderStore.jointPolygonsMap.values());

  useEffect(() => {
    renderCountRef.current++;
    if (editorStore.isDebugModeActive && editorStore.debugEdgeConnections) {
      console.log(
        `JointPolygonStructure render #${renderCountRef.current}: Rendering ${jointPolygons.length} joint polygon(s)`
      );
    }
  }, [jointPolygons.length, editorStore.debugEdgeConnections, editorStore.isDebugModeActive]);

  // Joint polygons always render to fill gaps at wall connections
  // Debug mode only affects additional logging, not rendering

  return (
    <group>
      {jointPolygons.map((polygon) => (
        <JointPolygon key={polygon.id} jointPolygon={polygon} />
      ))}
    </group>
  );
});

JointPolygonStructure.displayName = 'JointPolygonStructure';

export default JointPolygonStructure;
